import React from 'react';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';

const About: React.FC = () => {
    return (
        <>
            <section className="px-6 sm:px-12 lg:px-24 pt-24 sm:pt-32 pb-16 sm:pb-24">
                <div className="max-w-7xl mx-auto text-center">
                    {/* Hero text */}
                    <h1
                        className="text-white"
                        style={{
                            fontFamily: 'Manrope',
                            fontWeight: 500,
                            fontSize: 'clamp(56px, 9vw, 128px)',
                            lineHeight: 1.1,
                            letterSpacing: '-0.05em',
                        }}
                    >
                        About Hush
                    </h1>
                    <p
                        className="text-white mt-6 mx-auto"
                        style={{
                            fontFamily: 'Manrope',
                            fontWeight: 200,
                            fontSize: 'clamp(20px, 3vw, 45px)',
                            lineHeight: 1.35,
                            letterSpacing: '-0.05em',
                            maxWidth: 920,
                        }}
                    >
                        Smarter recruiting. Powered by AI. Built for people.
                    </p>

                    {/* Founder card — Card 2.png has the framed photo baked in;
                        Product.png is overlaid as the name tag on the left */}
                    <FadeInSection delay={0.1}>
                        <div
                            className="relative mx-auto mt-12 sm:mt-16"
                            style={{ maxWidth: 1208 }}
                        >
                            <img
                                src="/about/benjamin.png"
                                alt="Benjamin Pucci"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                }}
                            />
                            {/* Name tag — Figma spec, native CSS for responsiveness */}
                            <div
                                className="absolute flex flex-col items-center justify-center"
                                style={{
                                    top: '45%',
                                    left: '5%',
                                    transform: 'translateY(-50%)',
                                    width: 'clamp(220px, 26%, 367px)',
                                    aspectRatio: '367 / 151',
                                    padding: '0 24px',
                                    background: '#050505',
                                    mixBlendMode: 'screen',
                                    border: '0.75px solid #FFFFFF',
                                    borderRadius: '22.5px',
                                    boxShadow:
                                        '0px 3.75px 7.5px rgba(0, 0, 0, 0.05), 0px 11.25px 22.5px rgba(0, 0, 0, 0.05), 0px 22.5px 45px rgba(0, 0, 0, 0.1), inset 0px 277.5px 75px rgba(255, 255, 255, 0.2)',
                                    backdropFilter: 'blur(7.5px)',
                                    pointerEvents: 'none',
                                }}
                            >
                                <span
                                    style={{
                                        fontFamily: 'Manrope',
                                        fontWeight: 700,
                                        fontSize: 'clamp(22px, 2.4vw, 40px)',
                                        lineHeight: 1.1,
                                        letterSpacing: '-0.05em',
                                        color: '#FFFFFF',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    Benjamin Pucci
                                </span>
                                <span
                                    style={{
                                        marginTop: 6,
                                        fontFamily: 'Manrope',
                                        fontWeight: 200,
                                        fontSize: 'clamp(11px, 1.05vw, 18px)',
                                        lineHeight: 1.4,
                                        letterSpacing: '-0.05em',
                                        color: '#FFFFFF',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    Co-Founder & CEO
                                </span>
                            </div>
                        </div>
                    </FadeInSection>

                    {/* Body paragraph */}
                    <FadeInSection delay={0.15}>
                        <p
                            className="mx-auto mt-12 sm:mt-16"
                            style={{
                                fontFamily: 'Manrope',
                                fontWeight: 200,
                                fontSize: 'clamp(14px, 1.4vw, 24px)',
                                lineHeight: 1.44,
                                letterSpacing: '-0.02em',
                                color: 'rgba(255, 255, 255, 0.78)',
                                maxWidth: 1040,
                                textAlign: 'center',
                            }}
                        >
                            Hush is an AI-powered recruiting platform built to connect companies with top passive talent — the 70% of professionals who aren't actively applying but are open to the right opportunities. We believe in a smarter, fairer approach to hiring that respects candidate privacy and gives employers direct access to qualified talent.
                        </p>
                    </FadeInSection>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default About;
